/* eslint-disable */
export const environment = {
    apiUrl:  "https://suite-api-staging.swipesum.com/api",
    setRoot: true,
    logLevel: 5,
    reportLogging: false,
    portalUrl: "https://portal-staging.swipesum.com",
    firebaseConfig: {
        apiKey: "",
        authDomain: "suite-auth-staging.firebaseapp.com",
        projectId: "suite-auth-staging",
        storageBucket: "suite-auth-staging.firebasestorage.app",
        messagingSenderId: "1060403455506",
        appId: "1:1060403455506:web:6930f99b78146a4b2a9acb",
        measurementId: "G-5YQ8WBCV4J"
    },
    auditUrl: "https://audit-staging.swipesum.com",
    aiToolsUrl: "https://cpo-staging.swipesum.com/assets/ai-tools.html",
    suiteUrl: "https://cpo-staging.swipesum.com",
    apiDocsUrl: "https://external-api-staging.swipesum.com/swagger/index.html",
    auditDocsUrl: "https://cpo-staging.swipesum.com/assets/audit-documentation.html"
};
